import { NgModule } from '@angular/core';
import { NotificationsBackend } from './services/notifications.backend';

@NgModule({
  providers: [NotificationsBackend]
})
export class BackendModule {}
